<template>
  <main>
    <v-container class="grey lighten-4 fill-height">
      <v-row>
            <v-col class="mx-auto">
              <v-card class="elevation-12 ma-3">
                  <v-toolbar
                  color="primary"
                  dark
                  flat>
                  <v-toolbar-title>Översikt</v-toolbar-title>
                </v-toolbar>
                <v-card-text class="pa-5">
    <v-row>
    <v-col>
  <v-card
    max-width="344"
    outlined
  >
    <v-list-item three-line>
      <v-list-item-avatar
        tile
        size="80"
        color="#ffa500"
      ><v-icon dark x-large>fa-calendar-check</v-icon></v-list-item-avatar>
      <v-list-item-content>
        <div class="overline mb-4">Scheman</div>
        <v-list-item-title class="headline mx-5"><h2>{{schedule.schedule}}</h2></v-list-item-title>
      </v-list-item-content>

    </v-list-item>
  <v-divider></v-divider>
    <v-card-actions>
      <v-btn
        text
        block
        class="themecolor"
        to="/account/schedules"
      >
        Scheman
      </v-btn>
    </v-card-actions>
  </v-card>
    </v-col>
    <v-col>
  <v-card
    max-width="344"
    outlined
  >
    <v-list-item three-line>
      <v-list-item-avatar
        tile
        size="80"
        color="#ffa500"
      ><v-icon dark x-large>fa-comment-alt</v-icon></v-list-item-avatar>
      <v-list-item-content>
        <div class="overline mb-4">Kommentarer</div>
        <v-list-item-title class="headline mx-5"><h2>{{schedule.comments}}</h2></v-list-item-title>
      </v-list-item-content>

    </v-list-item>
<v-divider></v-divider>
    <v-card-actions>
      <v-btn
        text
        block
        class="themecolor"
        to="/account/comments"
      >
        Kommentarer
      </v-btn>
    </v-card-actions>
  </v-card>
    </v-col>
  </v-row>
  <v-row>
    <v-col>
        <h2 class="my-5">Schemalägg ett möte</h2>
        <p>Planerar du ett möte med vänner eller kollegor? Vårt verktyg kommer att vara en stor hjälp både för dig och för alla som deltar.</p>
        <v-btn
        color="#ffa500"
        
        to="/"
      >
        Schemalägg ett möte
      </v-btn>
    </v-col>
   </v-row>
                </v-card-text>
            </v-card>
            </v-col> 
        </v-row>
    </v-container>
  </main>
</template>

<script>
import axios from "axios";
import store from "../../store";
export default {
  name: "Dashboard",
  created: async function() {
    if (!this.store.state.isLoggedIn) this.$router.replace("/login");
    if (this.store.state.user.role == "admin")
      this.$router.replace("/admin/dashboard");
      var config = {
            method: "get",
            url: `${this.store.state.baseURL}schedulecount/${this.store.state.user.id}`,
            headers: {
                "Content-Type": "application/form-data;charset=utf-8",
                "Access-Control-Allow-Origin": "*",
                Accept: "*/*"
            }
        };
        let resp = await axios(config);
        this.schedule = resp.data;
  },
  data: () => ({
    isLoggedIn: null,
    store: store,
    schedule: '',
  }),
  methods: {
    reloadPage() {
      window.location.reload();
    },
  },
};
</script>
<style>
.themecolor {
  color:#ffa500 !important;
}
</style>